import { EventEmitter } from '@angular/core';
import { TemplateService } from '../../../../../services/template.service';
import { CALENDAR_LOCALE } from '../../../../../services/constant';
import { FormBuilder, Validators } from '@angular/forms';
import { combineLatest, concat, from, of, Subject } from 'rxjs';
import { ApiService } from '../../../../../services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, debounceTime, distinctUntilChanged, filter, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../../../../environments/environment';
import { AuthenticationService } from '../../../../../services/authentication.service';
import * as moment from 'moment';
var DocumentFormComponent = (function () {
    function DocumentFormComponent(apiService, authService, formBuilder, template, translateService) {
        this.apiService = apiService;
        this.authService = authService;
        this.formBuilder = formBuilder;
        this.template = template;
        this.translateService = translateService;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.documentRequestSelected = new EventEmitter;
        this.abbDataSelected = new EventEmitter();
        this.documentRequestInput$ = new Subject();
        this.searchingDocumentRequest = false;
        this.purposeError = false;
        this.abbNoInput$ = new Subject();
        this.searchingAbbNo = false;
        this.abbNoChecked = false;
        this.confirmationNoChecked = false;
        this.enabledCustomerRequest = environment.enabledCustomerRequest;
        this.today = new Date();
        this.calendarLocale = CALENDAR_LOCALE.EN;
        this.departments = [];
    }
    DocumentFormComponent.prototype.ngDoCheck = function () {
        this.changeCalendarLocale();
    };
    DocumentFormComponent.prototype.ngOnInit = function () {
        this.changeCalendarLocale();
        this.setDocumentTypes();
        this.createDocumentForm();
        this.loadDocumentRequest();
        this.loadAbbData();
        this.setMaxMinDate();
        this.loadDepartments();
        // any time the inner form changes update the parent of any change
        this.createSubscriptions();
        if (this.documentInformation) {
            if (this.documentInformation.header) {
                this.abbNoChecked = this.documentInformation.header.abb_no !== '';
                this.confirmationNoChecked = this.documentInformation.header.confirmation_no !== '';
                this.abbNo.enable();
                this.confirmationNo.enable();
            }
            else {
                this.abbNoChecked = this.documentInformation.abb_no !== '';
                this.confirmationNoChecked = this.documentInformation.confirmation_no !== '';
                this.abbNo.enable();
                this.confirmationNo.enable();
                this.returnDocumentDropdown(this.documentInformation);
            }
        }
    };
    DocumentFormComponent.prototype.processPurpose = function (event) {
        if (event.rd_document_type !== 'receipt_tax_invoice') {
            return null;
        }
        var issueDate = new Date(event.header.issue_dt);
        var issueDateDisplay = moment(issueDate).format('YYYY-MM-DDTHH:mm:ss') + ' GMT +7:00';
        return "\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01 \u0E41\u0E25\u0E30\u0E2D\u0E2D\u0E01\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E29\u0E35\u0E09\u0E1A\u0E31\u0E1A\u0E43\u0E2B\u0E21\u0E48\u0E41\u0E17\u0E19\u0E09\u0E1A\u0E31\u0E1A\u0E40\u0E14\u0E34\u0E21\u0E40\u0E25\u0E02\u0E17\u0E35\u0E48 " + event.header.invoice_number + " \u0E27\u0E31\u0E19\u0E17\u0E35\u0E48 " + issueDateDisplay;
    };
    DocumentFormComponent.prototype.setMaxMinDate = function () {
        if (this.isOperation() === true) {
            this.minSelectableDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
            this.maxSelectableDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        }
        else {
            this.minSelectableDate = new Date(2000, 0, 1);
            this.maxSelectableDate = new Date(2030, 11, 31);
        }
    };
    DocumentFormComponent.prototype.isOperation = function () {
        return this.authService.isOperation();
    };
    DocumentFormComponent.prototype.returnDocumentDropdown = function (documentInformation) {
        var _this = this;
        this.apiService.getDocumentRequestDropdown({ request_no: documentInformation.request_no }).subscribe(function (res) {
            _this.documentRequests$ = from([res]);
            _this.onChangeDocumentRequest(res);
        });
        if (documentInformation.abb_no) {
            this.apiService.getAbbDataDropdown({ abb_no: documentInformation.abb_no }).subscribe(function (res) {
                _this.abbData$ = from([res]);
                _this.onChangeAbbNo(res[0]);
                _this.loadAbbData(res);
            });
        }
    };
    Object.defineProperty(DocumentFormComponent.prototype, "currentLang", {
        get: function () {
            return this.translateService.currentLang;
        },
        enumerable: true,
        configurable: true
    });
    DocumentFormComponent.prototype.loadDocumentRequest = function () {
        var _this = this;
        this.documentRequests$ = concat(of([]), this.documentRequestInput$.pipe(filter(function (term) { return term != null && term.length >= 2; }), distinctUntilChanged(), debounceTime(300), tap(function () { return _this.searchingDocumentRequest = true; }), switchMap(function (term) {
            return _this.apiService.getDocumentRequestDropdown({ request_no: term }).pipe(catchError(function () { return of([]); }), tap(function () { return _this.searchingDocumentRequest = false; }));
        })));
    };
    DocumentFormComponent.prototype.loadAbbData = function (existedAbbData) {
        var _this = this;
        this.abbData$ = concat(existedAbbData ? of(existedAbbData) : of([]), this.abbNoInput$.pipe(filter(function (term) { return term != null && term.length >= 2; }), distinctUntilChanged(), debounceTime(300), tap(function () { return _this.searchingAbbNo = true; }), switchMap(function (term) {
            return _this.apiService.getAbbDataDropdown({ abb_no: term }).pipe(catchError(function () { return of([]); }), tap(function () { return _this.searchingAbbNo = false; }));
        })));
    };
    DocumentFormComponent.prototype.loadDepartments = function () {
        var _this = this;
        this.apiService.getDepartments().subscribe(function (res) {
            if (res.length > 0) {
                if (_this.translateService.currentLang === 'en') {
                    _this.departments = res.map(function (department) { return ({
                        label: department.name_en,
                        value: department.id,
                    }); });
                }
                else {
                    _this.departments = res.map(function (department) { return ({
                        label: department.name_th,
                        value: department.id,
                    }); });
                }
            }
        }, function (error) {
            console.log(error);
        });
    };
    DocumentFormComponent.prototype.changeDepartment = function (event) {
        this.getRunnningInvoiceNo(event.value);
        this.documentForm.patchValue({
            department: event.value,
        });
    };
    DocumentFormComponent.prototype.onChangeDocumentRequest = function (event) {
        if (event && event.confirmation_no) {
            this.confirmationNoChecked = true;
            this.confirmationNo.enable();
        }
        else {
            this.confirmationNoChecked = false;
            this.confirmationNo.disable();
        }
        this.documentForm.patchValue({
            confirmationNo: event ? event.confirmation_no : '',
        });
        event && event.length
            ? this.documentRequestSelected.emit(event[0])
            : this.documentRequestSelected.emit(event);
    };
    DocumentFormComponent.prototype.onChangeAbbNo = function (event) {
        this.abbDataSelected.emit(event);
    };
    DocumentFormComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    DocumentFormComponent.prototype.writeValue = function (value) {
        var _this = this;
        if (value) {
            value.documentNo = null;
            this.documentForm.setValue(value);
            if (this.docProcessType === 'reissue') {
                // unique cases doc type in dex 0 for cn dn is null
                if (!value.referenceDocuments[0].documentType) {
                    var required_1 = (this.isCreditNote || this.isDebitNote) ? Validators.required : null;
                    var refCnDnList = [];
                    for (var i = 0; i < JSON.parse(this.documentInformation.reference.doc_no_out_system.replace(/'/g, '"')).length; i++) {
                        refCnDnList.push({
                            documentNo: JSON.parse(this.documentInformation.reference.doc_no_out_system.replace(/'/g, '"'))[i],
                            documentType: JSON.parse(this.documentInformation.reference.document_type.replace(/'/g, '"'))[i],
                            documentDate: new Date(JSON.parse(this.documentInformation.reference.issue_dt.replace(/'/g, '"'))[i])
                        });
                    }
                    refCnDnList.forEach(function (ref, index) {
                        while (_this.referenceDocuments.length <= index) {
                            _this.referenceDocuments.push(_this.formBuilder.group({
                                documentNo: [null, required_1],
                                documentType: [null, required_1],
                                documentDate: [null, required_1]
                            }));
                        }
                        _this.referenceDocuments.at(index).setValue(ref);
                    });
                }
            }
            this.onChange(value);
            this.onTouched();
        }
    };
    DocumentFormComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    DocumentFormComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    // communicate the inner form validation to the parent form
    DocumentFormComponent.prototype.validate = function (_control) {
        var _this = this;
        return new Promise(function (resolve) {
            return _this.documentForm.valid ? resolve(null) : resolve({ documentForm: { valid: false } });
        });
    };
    DocumentFormComponent.prototype.createSubscriptions = function () {
        var _this = this;
        // Subscribe to valueChanges and statusChanges
        this.subscription = combineLatest([this.documentForm.valueChanges, this.documentForm.statusChanges]).subscribe(function () {
            _this.onChange(_this.documentForm.getRawValue());
            _this.onTouched();
        });
        this.documentForm.get('purpose').valueChanges.subscribe(function () {
            _this.documentForm.get('referenceDocuments.0').updateValueAndValidity(); // Trigger validation on purpose change
        });
    };
    DocumentFormComponent.prototype.setDocumentTypes = function () {
        var _this = this;
        this.documentTypes = this.template.getDropdown();
        if (this.isCreditNote || this.isDebitNote) {
            this.documentTypes.shift();
        }
        else {
            this.documentTypes = this.documentTypes.filter(function (element) { return element.value === _this.documentType; });
        }
    };
    DocumentFormComponent.prototype.changeCalendarLocale = function () {
        this.lang = localStorage.getItem('lang');
        this.calendarLocale = this.lang && this.lang === 'th' ? CALENDAR_LOCALE.TH : CALENDAR_LOCALE.EN;
    };
    Object.defineProperty(DocumentFormComponent.prototype, "isReceiptTaxInvoice", {
        get: function () {
            return this.documentType === 'receipt_tax_invoice';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "isCreditNote", {
        get: function () {
            return this.documentType === 'credit_note';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "isDebitNote", {
        get: function () {
            return this.documentType === 'debit_note';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "isDeliveryOrder", {
        get: function () {
            return this.documentType === 'delivery_order_tax_invoice';
        },
        enumerable: true,
        configurable: true
    });
    DocumentFormComponent.prototype.createDocumentForm = function () {
        var documentType = this.documentTypes.length === 1 ? this.documentTypes[0].value : null;
        var required = (this.isCreditNote || this.isDebitNote) ? Validators.required : null;
        this.documentForm = this.formBuilder.group({
            documentNo: [null, Validators.required],
            documentDate: [this.today, Validators.required],
            abbNo: [],
            confirmationNo: [{ value: null, disabled: true }],
            documentRequest: [],
            orderNo: [{ value: null, disabled: true }],
            runningNo: [{ value: null, disabled: true }],
            purpose: [null],
            department: this.isReceiptTaxInvoice ? [null, Validators.required] : [null],
            referenceDocuments: this.formBuilder.array([
                this.formBuilder.group({
                    documentNo: [null],
                    documentType: [documentType],
                    documentDate: [null]
                }, { asyncValidator: this.refDocumentValidator() })
            ])
        });
        if (this.documentInformation && this.documentInformation.header) {
            this.getRunnningInvoiceNo(this.documentInformation.header.department);
        }
    };
    DocumentFormComponent.prototype.refDocumentValidator = function () {
        var _this = this;
        return function (control) {
            var documentNoValue = control.get('documentNo') ? control.get('documentNo').value : null;
            var documentType = control.get('documentType') ? control.get('documentType').value : null;
            var documentDate = control.get('documentDate') ? control.get('documentDate').value : null;
            var purpose = _this.documentForm ? _this.documentForm.get('purpose').value : null;
            return of(null).pipe(switchMap(function () {
                var result = {};
                if ((documentNoValue && (documentType || _this.isReceiptTaxInvoice) && documentDate && purpose) || (!documentNoValue && (!documentType || _this.isReceiptTaxInvoice) && !documentDate && !purpose)) {
                    result = { documentNoRequired: false,
                        documentTypeRequired: false,
                        documentDateRequired: false };
                    _this.purposeError = false;
                    return of(null);
                }
                else {
                    result = { documentNoRequired: !documentNoValue,
                        documentTypeRequired: !documentType,
                        documentDateRequired: !documentDate };
                    _this.purposeError = !purpose;
                }
                return of(result);
            }));
        };
    };
    Object.defineProperty(DocumentFormComponent.prototype, "documentNo", {
        get: function () {
            return this.documentForm.get('documentNo');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "documentDate", {
        get: function () {
            return this.documentForm.get('documentDate');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "abbNo", {
        get: function () {
            return this.documentForm.get('abbNo');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "confirmationNo", {
        get: function () {
            return this.documentForm.get('confirmationNo');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "orderNo", {
        get: function () {
            return this.documentForm.get('orderNo');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "runningNo", {
        get: function () {
            return this.documentForm.get('runningNo');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "purpose", {
        get: function () {
            return this.documentForm.get('purpose');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "referenceDocuments", {
        get: function () {
            return this.documentForm.get('referenceDocuments');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "department", {
        get: function () {
            return this.documentForm.get('department');
        },
        enumerable: true,
        configurable: true
    });
    DocumentFormComponent.prototype.getReferenceDocument = function (index) {
        return this.referenceDocuments.controls[index];
    };
    DocumentFormComponent.prototype.getReferenceDocumentNo = function (index) {
        return this.referenceDocuments.controls[index].get('documentNo');
    };
    DocumentFormComponent.prototype.getReferenceDocumentType = function (index) {
        return this.referenceDocuments.controls[index].get('documentType');
    };
    DocumentFormComponent.prototype.getReferenceDocumentDate = function (index) {
        return this.referenceDocuments.controls[index].get('documentDate');
    };
    DocumentFormComponent.prototype.addReferenceDocument = function () {
        this.referenceDocuments.push(this.formBuilder.group({
            documentNo: [null, Validators.required],
            documentType: [null, Validators.required],
            documentDate: [null, Validators.required]
        }));
    };
    DocumentFormComponent.prototype.removeReferenceDocument = function (index) {
        this.referenceDocuments.removeAt(index);
    };
    DocumentFormComponent.prototype.getRunnningInvoiceNo = function (id) {
        var _this = this;
        if (!id) {
            return;
        }
        var params = {
            department_id: id,
        };
        this.apiService.getInvoiceNumber(params).subscribe(function (res) {
            if (res) {
                _this.documentForm.controls.documentNo.setValue(res);
            }
        }, function (error) {
            console.log(error);
        });
    };
    return DocumentFormComponent;
}());
export { DocumentFormComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/document-form/document-form.component.ts.pre-build-optimizer.js